import React from 'react'
import { connect } from 'react-redux'
import {
  Alert,
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import PageLoader from '../../components/PageLoader'
import integrationsActions from '../../integrations/actions'

class IntegrationDeleteConfirmModal extends React.Component {
  componentDidUpdate(prevProps) {
    const { onClose, deleteStatus } = this.props
    const { deleteStatus: prevDeleteStatus } = prevProps

    if (prevDeleteStatus === 'deleting' && deleteStatus === 'succeeded') {
      onClose()
    }
  }

  handleDelete(deleteProjects) {
    const { integration, dispatch } = this.props

    dispatch(integrationsActions.destroy(integration.id, deleteProjects))
  }

  hasProjects() {
    const { integration } = this.props
    return integration && integration.projects_count > 0
  }

  renderSimpleConfirmation() {
    const { onClose, t } = this.props

    return (
      <>
        <ModalBody>
          {t('IntegrationDeleteConfirmModal.message')}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => onClose()}>
            {t('buttons.cancel', { ns: 'commons' })}
          </Button>
          <Button
            className="text-white"
            color="danger"
            onClick={() => this.handleDelete(false)}
          >
            {t('buttons.confirm', { ns: 'commons' })}
          </Button>
        </ModalFooter>
      </>
    )
  }

  renderProjectsWarning() {
    const { integration, onClose, t } = this.props

    return (
      <>
        <ModalBody>
          <h5 className="mb-3">
            {t('IntegrationDeleteConfirmModal.projectsAssociated', {
              count: integration.projects_count
            })}
          </h5>
          <p className="text-muted">
            {t('IntegrationDeleteConfirmModal.projectsExplanation')}
          </p>
        </ModalBody>
        <ModalFooter className="d-flex flex-column gap-2">
          <div className="d-flex gap-2 w-100 justify-content-end">
            <Button color="secondary" onClick={() => onClose()}>
              {t('buttons.cancel', { ns: 'commons' })}
            </Button>
            <Button
              color="warning"
              onClick={() => this.handleDelete(false)}
            >
              {t('IntegrationDeleteConfirmModal.keepProjects')}
            </Button>
            <Button
              className="text-white"
              color="danger"
              onClick={() => this.handleDelete(true)}
            >
              {t('IntegrationDeleteConfirmModal.deleteAll')}
            </Button>
          </div>
        </ModalFooter>
      </>
    )
  }

  render() {
    const {
      deleteError,
      deleteStatus,
      isOpen,
      onClose,
      t
    } = this.props

    return (
      <Modal isOpen={isOpen} toggle={() => onClose()}>
        <Form>
          <ModalHeader toggle={() => onClose()}>
            {t('IntegrationDeleteConfirmModal.title')}
          </ModalHeader>

          {deleteStatus === 'deleting' && (
            <ModalBody>
              <PageLoader message={t('IntegrationDeleteConfirmModal.deleting')} />
            </ModalBody>
          )}

          {deleteStatus === 'failed' && (
            <ModalBody>
              <AlertMessage>{deleteError}</AlertMessage>
            </ModalBody>
          )}

          {deleteStatus !== 'deleting' && deleteStatus !== 'failed' && (
            this.hasProjects()
              ? this.renderProjectsWarning()
              : this.renderSimpleConfirmation()
          )}
        </Form>
      </Modal>
    )
  }
}

IntegrationDeleteConfirmModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    projects_count: PropTypes.number
  }),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  deleteError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  deleteStatus: PropTypes.string,
  t: PropTypes.func.isRequired
}

IntegrationDeleteConfirmModal.defaultProps = {
  integration: null,
  deleteError: null,
  deleteStatus: 'idle'
}

const mapStateToProps = ({
  integrations: {
    deleteError,
    deleteStatus
  }
}) => ({
  deleteError,
  deleteStatus
})

export default withTranslation(['SettingsPage', 'commons'])(
  connect(mapStateToProps)(IntegrationDeleteConfirmModal)
)
